<template>
  <el-dialog :title="action ? $t('text.firstLoginChangePassword') : $t('text.changePassword')"
             :visible.sync="dialogShow"
             :close-on-click-modal="false"
             @close="closeDialog"
             @open="openDialog">
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item :label="$t('text.oldPassword')"
                    :label-width="formLabelWidth"
                    prop="oldPassword">
        <el-input type="password"
                  v-model="form.oldPassword"
                  autocomplete="off"
                  :placeholder="$t('message.inputOldPassword')"/>
      </el-form-item>

      <el-form-item :label="$t('text.newPassword')"
                    :label-width="formLabelWidth"
                    prop="newPassword">
        <el-input
            type="password"
            v-model="form.newPassword"
            autocomplete="off"
            @blur="validateNewPassword"
            :placeholder="$t('message.inputNewPassword')"/>
        <div style="margin-top: 4px;">
          <span v-if="!clickCheck || this.newPasswordError === $t('message.passwordRequirement')"
                style="color: #999; font-size: 14px; text-align: left; display: block;margin-top: -12px;">
            {{ $t('message.passwordRequirement') }}
          </span>

          <span v-else style="color: #ec6665; font-size: 12px; text-align: left; display: block;margin-top: -12px;">
            {{ newPasswordError }}
          </span>
        </div>
      </el-form-item>

      <el-form-item :label="$t('text.confirmNewPassword')"
                    :label-width="formLabelWidth"
                    prop="newPasswordConfirm">
        <el-input type="password"
                  v-model="form.newPasswordConfirm"
                  autocomplete="off"
                  :placeholder="$t('message.confirmNewPassword')"/>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" @click="updatePassword">{{ $t('text.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SystemEdit',
  props: {
    show: Boolean,
    formData: Object,
    action: String,
  },
  data() {
    return {
      newPasswordError: this.$t('message.passwordRequirement'),
      dialogShow: this.show,
      loadingFail: false,
      clickCheck: false,
      form: {
        newPasswordConfirm: '',
        newPassword: '',
        oldPassword: '',
      },
      formLabelWidth: '200px',
      rules: {
        oldPassword: [
          {required: true, message: this.$t('message.inputOldPassword'), trigger: 'blur'},
        ],
        newPassword: [
          {required: true, message: ' ', trigger: 'blur'},
          {min: 8, max: 20, message: ' ', trigger: 'blur'},
        ],
        newPasswordConfirm: [
          {
            required: true,
            message: this.$t('message.confirmNewPassword'),
            trigger: 'blur'
          },
          {min: 8, max: 20, message: this.$t('message.newPasswordLengthError'), trigger: 'blur'},
        ],
      },
    }
  },
  methods: {
    openDialog() {
    },
    closeDialog() {
      this.newPasswordError = this.$t('message.passwordRequirement');
      this.loadingFail = false;
      this.clickCheck = false;
      this.dialogShow = false
      this.$refs['form'].resetFields() //关闭的时候重置表单
      this.$emit('update:show', false)
    },

    updatePassword() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          let oldPassword = this.form.oldPassword
          let newPassword = this.form.newPassword
          let newPasswordConfirm = this.form.newPasswordConfirm

          this.axios
              .post('/sysUserInfo/updatePassword', {
                oldPassword: oldPassword,
                newPassword: newPassword,
                newPasswordConfirm: newPasswordConfirm,
              })
              .then(res => {
                if (res.code === 200) {
                  this.$notify({
                    title: this.$t('text.success'),
                    message: res.msg,
                    type: 'success',
                  })

                  this.$store.commit('setIsLogin', false)
                  this.$store.commit('setUserId', null)
                  this.$store.commit('setUserName', null)
                  this.$store.commit('setRoutes', [])
                  this.$router.push('/login')

                  this.closeDialog()
                } else {
                  this.loadingFail = true
                  this.newPasswordError = res.msg
                  this.validateNewPassword()
                }
              })
        } else {
          return false
        }
      })
    },
    validateNewPassword() {
      this.clickCheck = true;
      const password = this.form.newPassword;
      if (!password) {
        this.newPasswordError = this.$t('message.inputNewPassword');
      } else if (password.length < 8 || password.length > 20) {
        this.newPasswordError = this.$t('message.newPasswordLengthError');
      } else if (this.loadingFail) {
        this.clickCheck = true;
      } else {
        this.newPasswordError = this.$t('message.passwordRequirement')
        this.clickCheck = false;
      }
    },
  },
  watch: {
    show(newVal) {
      this.dialogShow = newVal
    },
  },
}
</script>

<style scoped>
</style>